import moment from "moment";
import {useCallback} from "react";
import {ParamTypes} from "../constans/paramTypes";
import {useSQLChartFormatters} from "./useSQLChartFormatters";

export function useDetailsFormatter() {
    const dateFormatter = useCallback((value) => {
        if (!value) return "";
        if (!Array.isArray(value)) {
            if (typeof value === "object") return "";
            return moment(value).format("L");
        }
        return value.map((row) => moment(row).format("L")).join(", ");
    }, []);

    const numberFormatter = useCallback((value) => {
        if (value === null || value === undefined || typeof value !== "number")
            return "";
        return value.toFixed(2);
    }, []);

    const getParameterFormatter = useSQLChartFormatters();

    return useCallback(
        (name, parameter, key) => {
            if (parameter?.parameter === "MATH") return null;
            if (name.endsWith("_Date")) return dateFormatter;
            if (name.endsWith("_PlcmntID"))
                return getParameterFormatter(ParamTypes.LOCATION);
            if (name.endsWith("_Dictionary"))
                return getParameterFormatter(ParamTypes.DICTIONARY);
            if (name.endsWith("_Day"))
                return getParameterFormatter(ParamTypes.WEEK_DAY);
            if (name.endsWith("_User"))
                return getParameterFormatter(ParamTypes.USER);
            const amountFields = [
                "GroupDay",
                "Month",
                "Week",
                "Year",
                "CycleDay",
                "CycleWeek",
                "Cycle",
            ];
            if (amountFields.some((field) => name.endsWith(`_${field}`)))
                return getParameterFormatter(ParamTypes.AMOUNT, {precision: 0});
            if (
                [
                    "COUNT_ANIMAL",
                    "COUNT_ANIMAL_DISTINCT",
                    "COUNT_VALUES",
                    "COUNT_VALUES_DISTINCT",
                ].includes(parameter?.type)
            ) {
                return getParameterFormatter(key?.type);
            }

            switch (name) {
                // case "AnmID":
                // case "inseminationBoar":
                //     return animalFormatter;
                case "inseminationDate":
                case "usgDate":
                case "noPregnancy":
                    return dateFormatter;
                case "usgResult":
                    return getParameterFormatter(ParamTypes.RESULT);
                case "fallPigletsAge":
                    return numberFormatter;
                case "weighting":
                    return getParameterFormatter(ParamTypes.WEIGHT);
                case "plcmntID":
                    return getParameterFormatter(ParamTypes.LOCATION);
                case "race":
                    return getParameterFormatter(ParamTypes.RACE);
                case "raceCode":
                    return getParameterFormatter(ParamTypes.RACE_CODE);
                default:
                    // if (name.endsWith("_Date")) return dateFormatter;
                    // if (name.endsWith("_PlcmntID")) return getParameterFormatter(ParamTypes.LOCATION);
                    // if (name.endsWith("_Dictionary")) return getParameterFormatter(ParamTypes.DICTIONARY);
                    return getParameterFormatter(key?.type);
            }
        },
        [dateFormatter, numberFormatter, getParameterFormatter]
    );
}
